<template>
  <div id="admin-layout">
    <!-- admin header -->
    <LayoutHeader />

    <!-- admin sidebar-->
    <!-- <LayoutLeftMenu /> -->

    <!-- admin content-->
    <LayoutContent />

    <!-- admin footer-->
    <LayoutFooter />
  </div>
</template>


<style>
@import "./../../../assets/common/background/css/layout.css";
@import "./../../../assets/common/background/css/header.css";
@import "./../../../assets/common/background/css/content.css";
@import "./../../../assets/common/background/css/footer.css";
/* @import "./../assets/common/css/widget.css"; */
</style>

<script>
// @ is an alias to /src
import LayoutHeader from "./Header1.vue";
import LayoutContent from "./Content.vue";
import LayoutFooter from "./Footer.vue";

export default {
  name: "AdminLayout",
  components: {
    LayoutHeader,
    LayoutContent,
    LayoutFooter
  }
};
</script>